import { CategoriesApi } from '../../../API';
import { apiConfig } from '../../../utils/apiConfig';

export function useCategoriesAPI(): CategoriesApi {
  return new CategoriesApi(apiConfig);
}
